import StyledDateText from './StyledDateText';
import getPlannedEndDateColor from './getPlannedEndDateColor';
import formatPlannedEndDate from './formatPlannedEndDate';
import { CHALLENGE_NULL_COLOR } from '../../ChallengeView/ChallengeColorBar';

type PlannedEndDatePreviewProps = {
  date: string;
  challengeColor: string | null;
};

const PlannedEndDatePreview = ({
  date,
  challengeColor,
}: PlannedEndDatePreviewProps) => {
  const timestamp = new Date(date).getTime();
  const challengeHasColor =
    challengeColor !== null && challengeColor !== CHALLENGE_NULL_COLOR;

  return (
    <StyledDateText
      dateColor={getPlannedEndDateColor(timestamp)}
      challengeHasColor={challengeHasColor}
    >
      {formatPlannedEndDate(timestamp)}
    </StyledDateText>
  );
};

export default PlannedEndDatePreview;
